export default "__VITE_ASSET__Dwxoc3GB__"